import { render } from "./portfolio.vue?vue&type=template&id=2d913d0d"
import script from "./portfolio.vue?vue&type=script&lang=js"
export * from "./portfolio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__